export default "__VITE_ASSET__C99wE7kH__"